import gsap from 'gsap';
import { Sizes } from '../utils';

export class FlippingItem {
	constructor( selector, options = {} ) {
		this.elements = gsap.utils.toArray( selector );
		this.sizes = new Sizes();
		this.options = {
			devices: options?.devices || [ 'Desktop', 'Tablet', 'Mobile' ],
			power: options?.power || 1,
			duration: options.duration || 0.5,
			direction: options?.reversed ? -1 : 1,
		};
		this.isEnable = false;

		this.gsapDefaults = {};
		this.leaveFuncs = [];
		this.moveFuncs = [];
		this.xTo = [];
		this.yTo = [];
	}

	init() {
		if ( ! this.elements?.length ) return;
		if ( this.options.devices.includes( this.sizes.device ) ) {
			this.gsapDefaults.ease = 'expo.out';
			this.gsapDefaults.duration = this.options.duration;
			this.elements.forEach( ( item, index ) => {
				gsap.set( item, {
					transformPerspective: 1000,
					transformOrigin: 'center',
				} );
				this.xTo[ index ] = gsap.quickTo(
					item,
					'rotationY',
					this.gsapDefaults
				);
				this.yTo[ index ] = gsap.quickTo(
					item,
					'rotationX',
					this.gsapDefaults
				);
				this.leaveFuncs[ index ] = () =>
					this.#leave( this.xTo[ index ], this.yTo[ index ] );
				this.moveFuncs[ index ] = ( e ) =>
					this.#move( e, item, this.xTo[ index ], this.yTo[ index ] );
				item.addEventListener( 'mouseleave', this.leaveFuncs[ index ] );
				item.addEventListener( 'mousemove', this.moveFuncs[ index ] );
			} );
			this.isEnable = true;
		}
	}

	kill() {
		this.elements.forEach( ( item, index ) => {
			item.removeEventListener( 'mouseleave', this.leaveFuncs[ index ] );
			item.removeEventListener( 'mousemove', this.moveFuncs[ index ] );
			this.leaveFuncs[ index ] = null;
			this.moveFuncs[ index ] = null;
			this.xTo[ index ] = null;
			this.yTo[ index ] = null;
		} );
		gsap.killTweensOf( this.elements );
		gsap.set( this.elements, { clearProps: 'all' } );
		this.gsapDefaults = {};
		this.leaveFuncs = [];
		this.moveFuncs = [];
		this.xTo = [];
		this.yTo = [];
		this.isEnable = false;
	}

	resize() {
		if ( this.isEnable ) {
			this.kill();
		}
		if ( this.options.devices.includes( this.sizes.device ) ) {
			this.init();
		}
	}

	destroy() {
		this.kill();
		this.elements = null;
		this.sizes = null;
		this.options = null;
		this.gsapDefaults = null;
		this.leaveFuncs = null;
		this.moveFuncs = null;
		this.xTo = null;
		this.yTo = null;
		this.isEnable = null;
	}

	#leave( xTo, yTo ) {
		xTo( 0 );
		yTo( 0 );
	}

	#move( e, item, xTo, yTo ) {
		const x =
			( ( e.clientX -
				item.getBoundingClientRect().left -
				item.offsetWidth / 2 ) /
				item.offsetWidth ) *
			10 *
			this.options.power *
			this.options.direction;
		const y =
			( ( e.clientY -
				item.getBoundingClientRect().top -
				item.offsetHeight / 2 ) /
				item.offsetHeight ) *
			-10 *
			this.options.power *
			this.options.direction;
		xTo( x );
		yTo( y );
	}
}
